import { render, staticRenderFns } from "./UserInfoForm.component.vue?vue&type=template&id=4fbe505e&scoped=true"
import script from "./UserInfoForm.component.vue?vue&type=script&lang=js"
export * from "./UserInfoForm.component.vue?vue&type=script&lang=js"
import style0 from "./UserInfoForm.component.vue?vue&type=style&index=0&id=4fbe505e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe505e",
  null
  
)

export default component.exports